export const NOTIFICATION_READ_DELAY = 3000;
